import { SolicitacaoAAnalise } from "./SolicitacaoAcessoAnalise";

export default SolicitacaoAAnalise;